import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import './styles.css'

class LeaveHackathon extends Component {
  constructor (props) {
    super(props)

    this.dismissPopup = this.dismissPopup.bind(this)
    this.leaveHackathon = this.leaveHackathon.bind(this)
  }

  dismissPopup () {
    this.props.dispatch(actions.switchLeave({}))
  }

  leaveHackathon () {
    this.props.dispatch(actions.leaveHackathon())
  }

  render () {
    return (
      <div className='dashboard-popup-notif'>
        <div className='hey-popup-header'>
          <h4 className='header-text'>LEAVING HACKATHON</h4>
          <button
            onClick={this.dismissPopup}
            className='black-cross'>
            <img alt='' src='/imgs/close.png' />
          </button>
        </div>
        {/* <div className='line'>
          <div className='left'>
            <div> LEAVING HACKATHON</div>
          </div>
          <div className='center' />
          <div className='right' />
        </div>
        <div className='silver-line' /> */}
        {/* <div className='line'>
          <div className='left'>
            <div> From:</div>
            <div> To:</div>
          </div>
          <div className='center'>
            <div>Name Surname <span className='red'>@handle</span>
            </div>
            <div>me</div>
          </div>
          <div className='right'>
            <div className='cell-date'>
              DATE
            </div>
          </div>
        </div> */}
        {/* <div className='silver-line' /> */}
        <div className='pop-message-container '>
          <div className='dashboard-players2'>
            <div className='y-scroll-wrap2'>
              <div className='y-scroll2'>
                <div className='dashboard-players-list2'>
                  <div className='dashboard-players-row2'>
                    <div>
                      <span className='red'>
                        You are about to leave the Adidas Hackathon and DELETE your profile.
                        Please consider that this action cannot be undone.
                      </span>
                    </div>
                  </div>
                  <div className='dashboard-players-row2 leave-bttn'>
                    <button
                      onClick={this.leaveHackathon}
                      className='button'>leave hackathon</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect()(LeaveHackathon)



// WEBPACK FOOTER //
// ./src/components/common/popups/LeaveHackathon.js